<template>
    <div class="score_top_bar" :class="{ show: show }">
        <p class="username">{{ userName }}</p>
        <div class="score_detail" :class="[lang]">
            <p>{{ $t('base.totalPower') }} : {{ totalScore }}</p>
            <p>{{ $t('base.unredeemedPower') }} : {{ score }}</p>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { Bus } from '@/utils/eventBus.js';
export default {
    name: 'scoreTopBar',
    props: {
        // 是否显示
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    },
    computed: {
        lang() {
            return this.$store.state.lang;
        },
        userName() {
            return this.$store.state.userinfo
                ? this.$store.state.userinfo.user_name
                : '';
        },
        totalScore() {
            if (!this.$store.state.userinfo) return 0;
            return this.$store.state.userinfo.score_total;
        },
        score() {
            if (!this.$store.state.userinfo) return 0; // 未登录前，进度条设为最小值
            return this.$store.state.userinfo.score;
        }
    },
    mounted() {},
    methods: {
        ...mapMutations(['SHOW_POPUP', 'SET_LANG']),
        eventBusDemo() {
            Bus.$emit('_eventBusDemo');
        }
    }
};
</script>

<style lang="less" scoped>
.score_top_bar {
    position: absolute;
    width: 418px;
    height: 245px;
    z-index: -1;
    background: url('~@/assets/img/game/bg_score_topbar.png') center no-repeat;
    background-size: cover;
    top: 30px;
    left: 50%;
    margin-left: -418/2px;
    transform: translate(0, -280px);
    transition: 0.5s;
    opacity: 0;

    &.show {
        z-index: 2;
        transform: translate(0, 0);
        opacity: 1;
    }

    .username {
        width: 314px;
        height: 68px;
        line-height: 68px;
        font-size: 38px;
        color: #b35102;
        text-align: center;
        margin: 0 auto;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .score_detail {
        width: 370px;
        height: 140px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 30px auto 0;

        &.en {
            p {
                font-size: 24px;
                line-height: 40px;
            }
        }
        &.ru {
            p {
                font-size: 24px;
                line-height: 40px;
            }
        }

        p {
            font-size: 30px;
            line-height: 50px;
            color: #33160f;
        }
    }
}
</style>
